module.exports = __webpack_public_path__ + "img/title_txt_day1.622b81c3.png";